import './App.css';
import Footer from './footer.js';
import Header from './header';
import Ui, {NavigationBar} from './models/ui';


function NewComponent() {
	return (
		<b>This is new component</b>
	);
}

function OldComponent() {
	return (
		<h3 className='header'>Old Component</h3>
	);
}

function App() {
	return (
		<div className="App">
			<Header />
			<NavigationBar />
			<Ui />
			<OldComponent />
			<NewComponent />
			<Footer />
		</div>
	);
}

export default App;
